import React from 'react'

import { Link, graphql, useStaticQuery } from 'gatsby'

import { flatListToHierarchical } from '../../utils/wpMenuUtils'
import * as styles from './FooterMenu.module.scss'

const FooterMenu: React.FunctionComponent = () => {
	const data = useStaticQuery(graphql`
		query FooterMenu {
			wpMenu(locations: { in: SERVICE_MENU }) {
				name
				menuItems {
					nodes {
						id
						parentId
						label
						uri
						childItems {
							nodes {
								id
								parentId
							}
						}
					}
				}
			}
		}
	`)

	const sortedMenuItems = flatListToHierarchical(data.wpMenu.menuItems.nodes)

	return (
		<menu className={styles.footerMenu}>
			{sortedMenuItems.map((item) => {
				return (
					<li key={item.id}>
						<Link to={item.uri}>{item.label}</Link>
					</li>
				)
			})}
		</menu>
	)
}

export default FooterMenu
